import React, { Fragment } from "react"
import { ThemeProvider } from 'styled-components';
import Sticky from 'react-stickynode';

import Layout from "../components/layout"
import SEO from "../components/seo"
import { agencyTheme } from '../theme/';
import {  GlobalStyle,  AgencyWrapper } from '../theme/agency.style';
import { ResetCSS } from '../css/style';
import { DrawerProvider } from '../contexts/DrawerContext';
import Navbar from '../components/navbar';
import BannerSection from '../components/banner';
import FeatureSection from '../components/features';
import AboutUsSection from '../components/aboutus'
import ContactUsSection from '../components/contactus'
import Footer from '../components/footer'

const IndexPage = () => (
  <Layout>
    <ThemeProvider theme={agencyTheme}>
      <Fragment>
        <SEO title="Home" keywords={[`89Clouds`, `cloud consulting`, `data`, `machine learning`]} />
        <ResetCSS />
        <GlobalStyle />
        <AgencyWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <BannerSection />
          <FeatureSection />
          <AboutUsSection />
          <ContactUsSection />
          <Footer />
        </AgencyWrapper>
      </Fragment>
    </ThemeProvider>
  </Layout>
)

export default IndexPage
